export function focusFirstInvalidField(form: HTMLFormElement): boolean {
  const invalidControl = form.querySelector<HTMLElement>(
    ':invalid, [aria-invalid="true"]'
  );

  if (!invalidControl) {
    return false;
  }

  invalidControl.focus();
  return true;
}
